import Vue from "vue";
import * as Sentry from "@sentry/browser";
import { Vue as VueIntegration } from "@sentry/integrations";
import { Integrations } from "@sentry/tracing";
import { GLOBAL_ENV, SENTRY_DSN } from "@/constants";

Sentry.init({
  dsn: SENTRY_DSN,
  environment: GLOBAL_ENV,
  integrations: [
    new VueIntegration({
      Vue,
      tracing: true,
    }),
    new Integrations.BrowserTracing(),
  ],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
});

Sentry.setTag("platform", "frontend");
Sentry.setTag("app", "adalytics");
